import { ConfirmationDialog } from "@/components";

import { JobStatus } from "@/types";

const jobStatusToConfirmationButtonVariant: Record<
  JobStatus,
  "default" | "destructive"
> = {
  [JobStatus.ACTIVE]: "default", // We shouldn't be able to transition to `ACTIVE`.
  [JobStatus.REVIEW]: "default",
  [JobStatus.DRAFT]: "default",
  [JobStatus.CLOSED]: "destructive",
};

const jobStatusToConfirmationDescription: Record<JobStatus, string> = {
  [JobStatus.ACTIVE]: 'This will move this job into the "Active" status.', // We shouldn't be able to transition to `ACTIVE`.
  [JobStatus.REVIEW]:
    'This will move this job into the "In Review" status. It will be reviewed by the Laborup team shortly.',
  [JobStatus.DRAFT]: 'This will move this job into the "Draft" status.',
  [JobStatus.CLOSED]: 'This will move this job into the "Closed" status.',
};

export const JobStatusTransitionConfirmationDialog = ({
  jobStatus,
  onConfirm,
  onOpenChange,
  open,
  preventContentClickPropagation,
  preventOverlayClickCapturePropagation,
}: {
  jobStatus: JobStatus;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  preventContentClickPropagation?: boolean;
  preventOverlayClickCapturePropagation?: boolean;
}) => {
  return (
    <ConfirmationDialog
      confirmationButtonVariant={
        jobStatusToConfirmationButtonVariant[jobStatus]
      }
      description={jobStatusToConfirmationDescription[jobStatus]}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      open={open}
      preventContentClickPropagation={preventContentClickPropagation}
      preventOverlayClickCapturePropagation={
        preventOverlayClickCapturePropagation
      }
      title="Are you sure?"
    />
  );
};
